import "../scss/base_px.scss";
import "../scss/aticle_px.scss";

import "./mobileCommon";
import $ from "./jq";

import _ from "../../../common/js/templateEngine";

class Pager {
    constructor(){
        this.action = "https://global.37games.com/ajax/article_list";
        this.curPage = 0;
        this.total = 0;
        this.curLength = 0;
        this.ids = this.getids();
        this.pageLen = 15;
        this.gameId = 19;
        this.loading = false;
        this.template = `
            <% _.each(articles,function(article){ %>
                <li class="news-item j-news-item">
                    <a class="news-detail-link" href="<%= article.link %>" >
                        <p class="news-list-title"><%= article.title %></p>
                        <time class="publish-time"><%= article.time %></time>
                    </a>
                </li>
            <% }) %>
        `
        this.templateParser = _.template(this.template);
    }

    jsonp(url, parameter) {
       
       return new Promise((resolve)=>{
            $.ajax({
                url: url ,
                data: parameter,
                type: "get",
                dataType: "jsonp",
                success: (response) => {
                    this.loading = false;
                    if (1 == response.result) {
                        resolve({
                            msg : "", data : response.data, res : response
                        });
                    } else {
                        resolve( { msg : response.msg, data : response.data, res : response});
                    }
                },
                error: (e) => {
                    this.loading = false;
                    throw new Error(e.responseText);
                }
            });
       })
    };

    getids(){
        let ids = "";
        try{
            ids = location.pathname.match(/(id\/)([\d*\,*]+)/)[2];
        }catch(e){
            ids = "5,7";
        }
        return ids;
    }

    load(page){
        return new Promise((resolve)=>{
                this.jsonp(this.action,{
                        ids : this.ids,
                        page ,
                        num :this.pageLen,
                        gameId : this.gameId,
                        flags : "",
                        orderBy : "PUBLISH_TIME",
                        orderWay : "DESC"
                }).then(({msg,data,res})=>{
                        if(msg){
                            alert(msg)
                        }else{
                            this.total = data.total;
                            this.curLength += data.list.length;
                            this.curPage++;
                            resolve(this.matchData(data.list));
                        }
                })
        
        });
    }

    loadNextPage(){
        if(this.loading){
            return 
        }
        this.loading = true;
        let page = this.curPage + 1;
        this.load(page)
        .then((articles)=>{
            this.rend(articles)
        })
    }

    formatTime(time){
      let timeFormated = "";
      try{
        timeFormated = time.match(/\d+\:\d+$/)[0]
      }catch(e){
        timeFormated = time
      }
      return timeFormated;
    }

    matchData(articles){
        let newArticles = [];
        for(let i = 0,len = articles.length;i<len;i++){
            let article = {}
            article.title = articles[i].TITLE;
            article.flag = articles[i].FLAG;
            article.id = articles[i].ID;
            article.time = this.formatTime(articles[i].PUBLISH_TIME) ;
            article.link = `https://global.37games.com/article/view/id/${articles[i].ID}/m/${articles[i].ID}?ids=${this.ids}`
            newArticles.push(article)
        }
        return newArticles;
    }
    rend(articles){
        let html = this.templateParser({articles});
        let curList = $(".j-article-list-container").html();
        $(".j-article-list-container").html(curList + html);
    }

    hasNextPage(){
        return this.total >  this.curLength;
    }

}


(function(){
    let pager = new Pager();
    pager.loadNextPage();
    let lastScrollY = 0;
    let windowH= window.innerHeight;
    let bodyH = $("body").height();
    if($(".j-article-list-body").length>0){
        $(window).on("scroll",function(){
            let scrollY = window.scrollY;
            if( window.scrollY > bodyH - windowH - 200 && scrollY>lastScrollY && pager.hasNextPage()){
                pager.loadNextPage();
            }
            lastScrollY = scrollY;
        })
    }
})()